export default {
      id: "cal-white-usage",
      viewBox: "0 0 16.71 17.99",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#cal-white",
      toString: function () {
        return this.url;
      }
    }